import React from "react";
import s from '../../TablePage.module.scss'
import { Close, Done } from "@material-ui/icons";
import { useTranslation } from "react-i18next";


export const RawOfTableNewFiles = (props) => {
    const { t } = useTranslation()

    return (
        <tr className={s.raw_of_table}>
            <td><input id={props.id} type="checkbox" checked={props.check} onChange={(e) => props.handleClick(e, props.id)}/></td>
            <td className={s.raw_id}>{props.id}</td>
            {/* <td style={{ maxWidth: '100px' }}>{props.name}</td> */}
            <td className={s.birds_recognized}>
                <div className={s.birds_recognized_main}>{props.recognized_birds_species?.[0]}</div>
                {props.recognized_birds_species?.length > 1 && <div className={s.birds_recognized_hidden}>{props.recognized_birds_species?.join(', ')}</div>}
            </td>
            <td>{props.validated ?
                <Done className={s.icon_done} />  :
                <Close className={s.icon_close} />}</td>
            <td><audio className={s.table__audio} src={props.audiorecord_local} controls></audio></td>
            {/* <td>{props.userName}</td> */}
            <td>{props.created_at}</td>
            <td>{props.updated_at}</td>
            <td> 
                <button onClick={() => props.approveElements([props.id])} className={s.button__approve}>{t('approve')}</button>
                <button onClick={() =>  props.refuseElements([props.id])} className={s.button__refuse}>{t('refuse')}</button></td>
        </tr>
    )
}